import type { ReactNode } from 'react';

interface KpiCardProps {
  label: string;
  value: ReactNode;
  valueSuffix?: string;
  delta?: ReactNode;
  deltaDirection?: 'up' | 'down' | null;
}

export function KpiCard({
  label,
  value,
  valueSuffix,
  delta,
  deltaDirection = null,
}: KpiCardProps) {
  const deltaClass =
    deltaDirection === 'up'
      ? 'text-xs mt-1 text-tertiary [&>strong]:font-semibold [&>strong]:text-ok-deep'
      : deltaDirection === 'down'
      ? 'text-xs mt-1 text-tertiary [&>strong]:font-semibold [&>strong]:text-crit-deep'
      : 'text-xs mt-1 text-tertiary [&>strong]:font-semibold';

  return (
    <div className="glass-panel p-3.5 px-4 max-[760px]:p-3 max-[760px]:px-3.5">
      <div className="text-[11px] text-tertiary font-medium tracking-[0.02em] mb-1.5">
        {label}
      </div>
      <div className="text-2xl font-bold tracking-[-0.025em] tnum leading-[1.1] max-[760px]:text-xl">
        {value}
        {valueSuffix && (
          <span className="text-[13px] font-medium text-tertiary ml-0.5">{valueSuffix}</span>
        )}
      </div>
      {delta && <div className={deltaClass}>{delta}</div>}
    </div>
  );
}
